// 设置应用城市ID
export const APP__SET_CITY_ID = 'APP__SET_CITY_ID';
// 设置应用城市名称
export const APP__SET_CITY_NAME = 'APP__SET_CITY_NAME';
// 设置订单微信支付信息
export const APP__SET_WX_PAY_INFO = 'APP__SET_WX_PAY_INFO';
// 设置ticketInfoId
export const APP_SET_TICKET_INFO_ID = 'APP_SET_TICKET_INFO_ID';
